// axios
import axios from 'axios';
import store from '@/store/store';

const baseURL = 'http://localhost:8080/customer-api';


const instance = axios.create({
  baseURL
  // You can add your headers here
});

instance.interceptors.request.use(function (config) {
  const token = store.state.account.accessToken;
  config.headers.Authorization = token;
  return config;
});


export default instance;
